import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, Injector, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { RightBridgeApiService } from '../services/right-bridge-api.service';
import { Router } from '@angular/router';
import { bypassApps } from '../lib/bypassApps';

@Injectable()
export class VerifyImplementation implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const requestedApp = req.headers.get('x-rb-i');
    const requestApp =
      !requestedApp || bypassApps.includes(requestedApp) ? 'rb' : requestedApp;
    req = req.clone({ setHeaders: { 'x-rb-i': requestApp } });
    return next.handle(req);
  }
}

@Injectable()
export class NoCacheHeadersInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const authReq = req.clone({
      setHeaders: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
      },
    });
    return next.handle(authReq);
  }
}

@Injectable()
export class ErrorCatch implements HttpInterceptor {
  private router = inject(Router);
  private injector = inject(Injector);


  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError(err => {
        if (err.status === 403) {
          this.router.navigate(['/not-allowed']);
        } else if (err.status === 401) {
          this.injector.get(RightBridgeApiService).logout();
        } else {
          console.error('Network error: ' + err);
        }

        const error = err.error || err.statusText;

        return throwError(() => err);
      })
    );
  }
}
